import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import { Symbol } from "../../../../../constants";
import { routes } from "../../../../../routers/routes";
import { DetailsProp } from "../../../../../types/Ecommerce";

//This component displays product details, including name, rating, price, and discount price.
const Details: React.FC<DetailsProp> = ({ item }) => {

  return (
    <div className="product-details">
      <Rating fillColor="#ffa800" initialValue={Math.random() * 5} size={17} />
      <Link to={routes.ECommerce.ProductPage}>
        <h4>{item.name}</h4>
      </Link>
      <p>{item.note}</p>
      <div className="product-price">
        {Symbol}
        {item.price}
        <del className="f-w-700">
          {Symbol}
          {item.discountPrice}
        </del>
      </div>
    </div>
  );
};
export default Details;